import I18n from 'I18n';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import Raven from 'raven-js';
import * as ApiNames from 'self-service-api/constants/ApiNames';
import * as UpgradeProducts from 'self-service-api/constants/UpgradeProducts';
import { trackFailedApiNameMap } from '../../utils/metricUtils';
export const i18nKeysByUpgradeProduct = {
  [UpgradeProducts.SALES_PRO]: 'salesPro',
  [UpgradeProducts.SALES_STARTER]: 'salesStarter',
  [UpgradeProducts.SALES_PROFESSIONAL]: 'salesProfessional',
  [UpgradeProducts.SALES_ENTERPRISE]: 'salesEnterprise',
  [UpgradeProducts.SUITE_STARTER]: 'suiteStarter',
  [UpgradeProducts.SUITE_PROFESSIONAL]: 'suiteProfessional',
  [UpgradeProducts.SUITE_ENTERPRISE]: 'suiteEnterprise',
  [UpgradeProducts.MARKETING_STARTER]: 'marketingStarter',
  [UpgradeProducts.MARKETING_STARTER_EMAIL]: 'marketingStarterEmail',
  [UpgradeProducts.MARKETING_BASIC]: 'marketingBasic',
  [UpgradeProducts.MARKETING_PRO]: 'marketingProfessional',
  [UpgradeProducts.MARKETING_ENTERPRISE]: 'marketingEnterprise',
  [UpgradeProducts.MARKETING_PLUS_PROFESSIONAL]: 'marketingPlusProfessional',
  [UpgradeProducts.MARKETING_PLUS_ENTERPRISE]: 'marketingPlusEnterprise',
  [UpgradeProducts.SERVICE_STARTER]: 'serviceStarter',
  [UpgradeProducts.SERVICE_PROFESSIONAL]: 'serviceProfessional',
  [UpgradeProducts.SERVICE_ENTERPRISE]: 'serviceEnterprise',
  [UpgradeProducts.OPERATIONS_STARTER]: 'operations-starter',
  [UpgradeProducts.OPERATIONS_PROFESSIONAL]: 'operations-professional',
  [UpgradeProducts.OPERATIONS_ENTERPRISE]: 'operations-enterprise',
  [UpgradeProducts.ADS]: 'ads',
  [UpgradeProducts.WEBSITE]: 'website',
  [UpgradeProducts.REPORTING]: 'reporting',
  [UpgradeProducts.DEDICATED_IP]: 'dedicatedIp',
  [UpgradeProducts.TRANSACTIONAL_EMAIL]: 'transactionalEmail',
  [UpgradeProducts.ADDITIONAL_ACCOUNT]: 'additionalAccount',
  [UpgradeProducts.DESIGNATED_TECHNICAL_SUPPORT]: 'designatedTechnicalSupport',
  [UpgradeProducts.IN_PERSON_TRAINING]: 'inPersonTraining',
  [UpgradeProducts.ENTERPRISE]: 'enterprise',
  [UpgradeProducts.CMS_ENTERPRISE]: 'cmsEnterprise',
  [UpgradeProducts.CMS_PROFESSIONAL]: 'cmsProfessional',
  [UpgradeProducts.CMS_STARTER]: 'cmsStarter',
  [UpgradeProducts.CUSTOM_SSL]: 'customSsl',
  [UpgradeProducts.DOMAINS_LIMIT_INCREASE]: 'domains-limit-increase',
  [UpgradeProducts.SANDBOX_LIMIT_INCREASE]: 'sandbox-limit-increase',
  [UpgradeProducts.CALLING_LIMIT_INCREASE]: 'calling-limit-increase',
  [UpgradeProducts.PHONE_LIMIT_INCREASE]: 'phone-limit-increase',
  [UpgradeProducts.TEAMS_LIMIT_INCREASE]: 'teams-limit-increase',
  [UpgradeProducts.WHATSAPP_LIMIT_INCREASE]: 'whatsapp-limit-increase',
  [UpgradeProducts.VIDEO_LIMIT_INCREASE]: 'video-limit-increase',
  [UpgradeProducts.MARKETING_SMS_ADDON]: 'marketing-sms',
  [UpgradeProducts.MARKETING_SMS_LIMIT_INCREASE]: 'marketing-sms-limit-increase',
  [UpgradeProducts.STARTER_CONTACTS]: 'starter-contacts',
  [UpgradeProducts.ESIGNATURE_LIMIT_INCREASE]: 'esignature-limit-increase',
  [UpgradeProducts.WORKFLOWS_ADDON]: 'workflows-addon',
  [UpgradeProducts.WORKFLOWS_LIMIT_INCREASE]: 'workflows-limit-increase',
  [UpgradeProducts.USERS_LIMIT_INCREASE]: 'users-limit-increase',
  [UpgradeProducts.CUSTOM_OBJECTS_LIMIT_INCREASE]: 'custom-objects-limit-increase',
  [UpgradeProducts.CALCULATED_PROPERTIES_LIMIT_INCREASE]: 'calculated-properties-limit-increase',
  [UpgradeProducts.CUSTOM_PROPERTIES_LIMIT_INCREASE]: 'custom-properties-limit-increase',
  [UpgradeProducts.CRM_OBJECT_LIMIT_INCREASE]: 'crm-object-limit-increase',
  [UpgradeProducts.CRM_CONTACT_RECORDS_LIMIT_INCREASE]: 'non-marketing-contacts-limit-increase',
  [UpgradeProducts.MARKETING_SMS_SHORT_CODE]: 'marketing-sms-short-code',
  [UpgradeProducts.COMMERCE_PROFESSIONAL]: 'commerce-hub-professional',
  [UpgradeProducts.COMMERCE_ENTERPRISE]: 'commerce-hub-enterprise',
  [UpgradeProducts.CORE_SEATS_PROFESSIONAL]: 'core-seats-professional',
  [UpgradeProducts.CORE_SEATS_ENTERPRISE]: 'core-seats-enterprise'
};
export const i18nKeysByApiName = {
  [ApiNames.HUBSPOT_FREE]: 'hubspotFree',
  [ApiNames.MARKETING_HUB_FREE]: 'hubspotFree',
  [ApiNames.SALES_HUB_FREE]: 'hubspotFree',
  [ApiNames.SERVICE_HUB_FREE]: 'hubspotFree',
  [ApiNames.OPERATIONS_HUB_FREE]: 'hubspotFree',
  [ApiNames.CMS_HUB_FREE]: 'hubspotFree',
  [ApiNames.SALES_HUB_STARTER]: 'salesStarter',
  [ApiNames.SALES_HUB_PROFESSIONAL]: 'salesPro',
  [ApiNames.SALES_HUB_ENTERPRISE]: 'salesEnterprise',
  [ApiNames.MARKETING_HUB_BASIC]: 'marketingBasic',
  [ApiNames.MARKETING_HUB_STARTER]: 'marketingStarter',
  [ApiNames.MARKETING_HUB_PROFESSIONAL]: 'marketingProfessional',
  [ApiNames.MARKETING_HUB_ENTERPRISE]: 'marketingEnterprise',
  [ApiNames.SERVICE_HUB_STARTER]: 'serviceStarter',
  [ApiNames.SERVICE_HUB_PROFESSIONAL]: 'serviceProfessional',
  [ApiNames.SERVICE_HUB_ENTERPRISE]: 'serviceEnterprise',
  [ApiNames.OPERATIONS_HUB_STARTER]: 'operations-starter',
  [ApiNames.OPERATIONS_HUB_PROFESSIONAL]: 'operations-professional',
  [ApiNames.OPERATIONS_HUB_ENTERPRISE]: 'operations-enterprise',
  [ApiNames.CMS_HUB_STARTER]: 'cmsStarter',
  [ApiNames.CMS_HUB_PROFESSIONAL]: 'cmsProfessional',
  [ApiNames.CMS_HUB_ENTERPRISE]: 'cmsEnterprise',
  [ApiNames.CRM_SUITE_STARTER_BUNDLE]: 'crm-suite-starter-bundle',
  [ApiNames.CRM_SUITE_PROFESSIONAL_BUNDLE]: 'crm-suite-professional-bundle',
  [ApiNames.CRM_SUITE_ENTERPRISE_BUNDLE]: 'crm-suite-enterprise-bundle',
  [ApiNames.MARKETING_PLUS_PROFESSIONAL_BUNDLE]: 'marketing-plus-professional-bundle',
  [ApiNames.MARKETING_PLUS_ENTERPRISE_BUNDLE]: 'marketing-plus-enterprise-bundle',
  [ApiNames.ADS_LIMIT_INCREASE]: 'ads',
  [ApiNames.REPORTING_LIMIT_INCREASE]: 'reporting',
  [ApiNames.DEDICATED_IP]: 'dedicatedIp',
  [ApiNames.TRANSACTIONAL_EMAIL]: 'transactionalEmail',
  [ApiNames.CUSTOM_SSL]: 'customSsl',
  [ApiNames.MARKETING_SMS_ADDON]: 'marketing-sms',
  [ApiNames.MARKETING_SMS_LIMIT_INCREASE]: 'marketing-sms-limit-increase',
  [ApiNames.DOMAINS_LIMIT_INCREASE]: 'domains-limit-increase',
  [ApiNames.SANDBOX_LIMIT_INCREASE]: 'sandbox-limit-increase',
  [ApiNames.CALLING_LIMIT_INCREASE]: 'calling-limit-increase',
  [ApiNames.PHONE_LIMIT_INCREASE]: 'phone-limit-increase',
  [ApiNames.TEAMS_LIMIT_INCREASE]: 'teams-limit-increase',
  [ApiNames.WHATSAPP_LIMIT_INCREASE]: 'whatsapp-limit-increase',
  [ApiNames.VIDEO_LIMIT_INCREASE]: 'video-limit-increase',
  [ApiNames.ESIGNATURE_LIMIT_INCREASE]: 'esignature-limit-increase',
  [ApiNames.WORKFLOWS_LIMIT_INCREASE]: 'workflows-limit-increase',
  [ApiNames.USERS_LIMIT_INCREASE]: 'users-limit-increase',
  [ApiNames.CUSTOM_OBJECTS_LIMIT_INCREASE]: 'custom-objects-limit-increase',
  [ApiNames.CALCULATED_PROPERTIES_LIMIT_INCREASE]: 'calculated-properties-limit-increase',
  [ApiNames.CUSTOM_PROPERTIES_LIMIT_INCREASE]: 'custom-properties-limit-increase',
  [ApiNames.CRM_OBJECT_LIMIT_INCREASE]: 'crm-object-limit-increase',
  [ApiNames.CRM_CONTACT_RECORDS_LIMIT_INCREASE]: 'non-marketing-contacts-limit-increase',
  [ApiNames.SERVICE_HUB_PROFESSIONAL_ONBOARDING]: 'service-hub-professional-onboarding',
  [ApiNames.SALES_HUB_PROFESSIONAL_ONBOARDING]: 'sales-hub-professional-onboarding',
  [ApiNames.BREEZE_INTELLIGENCE_CREDITS_100]: 'breeze-intelligence-credits-100',
  [ApiNames.BREEZE_INTELLIGENCE_CREDITS_1000]: 'breeze-intelligence-credits-1000',
  [ApiNames.BREEZE_INTELLIGENCE_CREDITS_10000]: 'breeze-intelligence-credits-10000',
  [ApiNames.BREEZE_INTELLIGENCE_CREDITS_100_COMMITTED]: 'breeze-intelligence-credits-100-committed',
  [ApiNames.BREEZE_INTELLIGENCE_CREDITS_1000_COMMITTED]: 'breeze-intelligence-credits-1000-committed',
  [ApiNames.BREEZE_INTELLIGENCE_CREDITS_10000_COMMITTED]: 'breeze-intelligence-credits-10000-committed',
  [ApiNames.COMMERCE_HUB_PROFESSIONAL]: 'commerce-hub-professional',
  [ApiNames.COMMERCE_HUB_ENTERPRISE]: 'commerce-hub-enterprise',
  [ApiNames.CORE_SEATS_PROFESSIONAL]: 'core-seats-professional',
  [ApiNames.CORE_SEATS_ENTERPRISE]: 'core-seats-enterprise'
};
export const getProductNameTextFromApiName = apiName => {
  const productTitleKey = i18nKeysByApiName[apiName];
  if (!isValidI18nKey(`upgrades.products.${productTitleKey}`)) {
    trackFailedApiNameMap('getProductNameTextFromApiName', apiName, 'no upgrade product');
    return I18n.text('upgrades.products.default');
  }
  return I18n.text(`upgrades.products.${productTitleKey}`);
};
export const getProductNameText = upgradeProduct => {
  const productTitleKey = i18nKeysByUpgradeProduct[upgradeProduct];
  if (!isValidI18nKey(`upgrades.products.${productTitleKey}`)) {
    Raven.captureException(new Error(`failed to get product name text from upgradeProduct ${upgradeProduct} in getProductNameText`));
    return I18n.text('upgrades.products.default');
  }
  return I18n.text(`upgrades.products.${productTitleKey}`);
};
export const getTranslatedProductName = (apiName, upgradeProduct) => {
  const defaultText = I18n.text('upgrades.products.default');
  const apiNameLanguageKey = apiName && `upgrades.products.${i18nKeysByApiName[apiName]}`;
  const upgradeProductLanguageKey = `upgrades.products.${i18nKeysByUpgradeProduct[upgradeProduct]}`;
  if (apiNameLanguageKey && isValidI18nKey(apiNameLanguageKey)) {
    return I18n.text(apiNameLanguageKey);
  } else if (isValidI18nKey(upgradeProductLanguageKey)) {
    trackFailedApiNameMap('getProductNameTextFromApiName', apiName || 'undefined apiName', 'no upgrade product');
    return I18n.text(upgradeProductLanguageKey);
  } else {
    Raven.captureException(new Error(`failed to get product name text from upgradeProduct ${upgradeProduct} in getProductNameText`));
    return defaultText;
  }
};